import { ResultWithType, TableRowType } from '../ViewDCRModal/_hooks/useDcr';

export const isChangeRow = (row: TableRowType): row is ResultWithType => {
	return 'field' in row;
};
